import { useDispatch, useSelector } from 'react-redux'
import { useInputWithMaxLength } from '../../../hooks/useInput'
import CustomModal from '../../../components/CustomModal'
import { tryCreateBannerType, tryUpdateBannerType } from '../../../redux/slices/bannerSlices'
import { useEffect, useState } from 'react'
import FocusedCustomPresets from '../../focusItems/presets/FocusedCustomPresets'
import { savedBannerPresets } from '../../focusItems/constants'
import Input from '../../../components/form/Input'
import isEmpty from 'lodash/isEmpty'

const BannerTypeCreatorModal = ({ showModal, setShowModal }) => {
  const dispatch = useDispatch()

  const processing = useSelector((state) => state.banner.pages.processing)
  const title = useInputWithMaxLength('', 20)
  const [selectedPreset, setSelectedPreset] = useState(
    savedBannerPresets[0].values,
  )
  const [editing, setEditing] = useState(false)

  useEffect(() => {
    if (showModal) {
      if (!isEmpty(showModal)) {
        setSelectedPreset(showModal?.extras)
        title.setValue(showModal?.title)
        setEditing(true);
      } else {
        setSelectedPreset(savedBannerPresets[0].values)
      }
    }
  }, [showModal])

  return (
    <CustomModal
      title="Banner Type"
      showModal={!!showModal}
      setShowModal={setShowModal}
      buttonLabel={editing ? "Update" : "Create"}
      onClick={() => {
        if(!isEmpty(showModal)){
          dispatch(
            tryUpdateBannerType({
              title: title.value.trim(),
              extras: selectedPreset
            }),
          )
        }else{
          dispatch(
            tryCreateBannerType({
              title: title.value.trim(),
              extras: selectedPreset,
            }),
          )
        }
        
      }}
      loading={processing}
      disabled={!title.value.trim()}
    >
      {!!showModal && (
        <FocusedCustomPresets
          presets={savedBannerPresets}
          preset={selectedPreset}
          setPreset={setSelectedPreset}
          isFocused={false}
          defaultRows={1}
          editing={editing}
        />
      )}
      <Input
        type="text"
        label="Banner Title"
        placeholder="Title"
        onChange={title.onChange}
        value={title.value}
      />
    </CustomModal>
  )
}

export default BannerTypeCreatorModal
